import { Logger } from 'lib'
import { IVideoPlayer } from '../types'
import { StreamTypes, VideoPlayerStates } from '../constants'

const PLAYER_ID = 'video-player-kick'

export default class VideoPlayerKick extends IVideoPlayer {
  #endMillis

  #frame

  #logger = new Logger(VideoPlayerKick.name)

  #startMillis

  #state = VideoPlayerStates.Unstarted

  #uuid

  #renderFrame () {
    const container = document.getElementById(PLAYER_ID)

    if (!container) {
      return
    }

    const frame = document.createElement('iframe')
    const frameSrc = new URL(this.#uuid, 'https://player.kick.com')

    frameSrc.searchParams.set('autoplay', 'true')
    frameSrc.searchParams.set('muted', 'true')

    frame.setAttribute('allowfullscreen', 'true')
    frame.setAttribute('frameborder', '0')
    frame.setAttribute('height', '100%')
    frame.setAttribute('scrolling', 'no')
    frame.setAttribute('src', frameSrc.href)
    frame.setAttribute('width', '100%')

    if (this.#frame) {
      this.#frame.remove()
      this.#frame = undefined
    }

    container.appendChild(frame)
    this.#frame = frame
    this.#state = VideoPlayerStates.Playing
  }

  getState () {
    return this.#state
  }

  loadById (
    tournamentId,
    uuid,
    streamType,
    startMillis,
    endMillis,
    timelineEvent,
    timeline,
    // eslint-disable-next-line no-unused-vars
    leagueSlug
  ) {
    if (streamType !== StreamTypes.Live) {
      this.#logger.warn('Kick only supports live streams')
      return
    }

    this.#endMillis = endMillis
    this.#startMillis = startMillis || 0
    this.#uuid = uuid
    this.#renderFrame()
  }

  pause () {
    this.#logger.warn("Kick doesn't support programmatic actions.")
  }

  play () {
    this.#logger.warn("Kick doesn't support programmatic actions.")
  }

  remove () {
    if (!this.#frame) {
      return
    }

    this.#frame.remove()
    this.#frame = undefined
  }

  render () {
    return <div id={ PLAYER_ID }/>
  }

  setup (
    tournamentId,
    uuid,
    streamType,
    startMillis,
    endMillis,
    timelineEvent,
    timeline,
    leagueSlug
  ) {
    this.loadById(
      tournamentId,
      uuid,
      streamType,
      startMillis,
      endMillis,
      timelineEvent,
      timeline,
      leagueSlug
    )
  }

  get endMillis () {
    return this.#endMillis
  }

  get startMillis () {
    return this.#startMillis
  }

  get uuid () {
    return this.#uuid
  }
}
